/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGroupMeditationTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGroupMeditation,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Meditate Together!",
    "Group Meditation Session Awaits!",
    "Find Your Inner Peace!",
  ],
  title: "Group Meditation",
  description: "Organize a calming group meditation session.",
  longDescription:
    "Gather your friends for a relaxing group meditation! Choose a date, decide on meditation styles, and plan the environment!",
  emoji: "🧘",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Group Meditation",
          emoji: "🧘",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the group meditation session?",
          emoji: "📅",
          completeAction: {
            question: "Decide on meditation styles?",
            description:
              "What meditation styles should we explore during the session?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What meditation styles should we consider?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on a peaceful environment?",
                  description:
                    "What environment should we create for the meditation?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What environment should we aim for?",
                      emoji: "🌅",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Find Our Peace!",
    outroDescription:
      "Your group meditation plans are set! Enjoy the tranquility!",
  },
};
